module.exports = __webpack_public_path__ + "img/Les durs à cuire.9f387ae9.png";